import React, { createContext, useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import BaseMapView from 'map/BaseMapView';
import Paper from '@mui/material/Paper';
import styles from '../../css/rdTrf.module.css';
import PlaceIcon from '@mui/icons-material/Place';
import { Box, Stack, Typography } from '@mui/material';
import CommonBoundaryLayer from 'map/layers/CommonBoundaryLayer';
import CommonGuidelineLayer from 'map/layers/CommonGuidelineLayer';
import CommonMarkerLayer from 'map/layers/CommonMarkerLayer';
import ApiService from 'services/ApiService';
import { ToFeatures } from 'services/GeoJsonService';
import BoundaryVmsLayer from 'map/layers/BoundaryVmsLayer';
import Slider from "@mui/material/Slider";
import IconButton from '@mui/material/IconButton';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import PauseIcon from '@mui/icons-material/Pause';
const TrafficInOutHourContext = createContext(null);

export function SwItsTrafficOdProvider({ children }) {
    const [dataByHour, setDataByHour] = useState([]);
    const [step, setStep] = useState(0);
    const [maxStep, setMaxStep] = useState(23); // 기본 0~23시
    const [isPlaying, setIsPlaying] = useState(false);
    const [timerDate, setTimerDate] = useState(getToday()); // 날짜 상태 추가

    const animationRef = useRef();

    const formatDateForApi = (dateStr) => {
        return dateStr.replace(/-/g, ''); // "2025-05-19" → "20250519"
    };

    // const startPlayback = () => {
    //     if (isPlaying) return;

    //     let lastUpdateTime = Date.now();
    //     const interval = 1000; // 1초

    //     const animate = () => {
    //         const now = Date.now();
    //         const delta = now - lastUpdateTime;

    //         if (delta >= interval) {
    //             setStep(prev => {
    //                 if (prev < maxStep) {
    //                     lastUpdateTime = now;
    //                     return prev + 1;
    //                 } else {
    //                     stopPlayback(); // 멈춤 호출
    //                     return prev;
    //                 }
    //             });
    //         }

    //         if (animationRef.current) {
    //             animationRef.current = requestAnimationFrame(animate);
    //         }
    //     };

    //     animationRef.current = requestAnimationFrame(animate);
    //     setIsPlaying(true);
    // };
    const startPlayback = () => {
        if (isPlaying) return;

        // 끝까지 도달한 경우만 처음으로 되돌리기
        if (step >= maxStep) {
            setStep(0);
        }

        let lastUpdateTime = Date.now();
        const interval = 1000;

        const animate = () => {
            const now = Date.now();
            const delta = now - lastUpdateTime;

            if (delta >= interval) {
                setStep(prev => {
                    if (prev < maxStep) {
                        lastUpdateTime = now;
                        return prev + 1;
                    } else {
                        stopPlayback();
                        return prev;
                    }
                });
            }

            if (animationRef.current) {
                animationRef.current = requestAnimationFrame(animate);
            }
        };

        animationRef.current = requestAnimationFrame(animate);
        setIsPlaying(true);
    };
    const stopPlayback = () => {
        if (animationRef.current) {
            cancelAnimationFrame(animationRef.current);
            animationRef.current = null;
        }
        setIsPlaying(false);
        setStep(0); // Stop은 처음으로 되돌리기
    };

    const pausePlayback = () => {
        console.log('pause ::: >???')
        if (animationRef.current) {
            cancelAnimationFrame(animationRef.current);
            animationRef.current = null;
        }
        setIsPlaying(false);
        // step은 현재 위치 유지 (되돌리지 않음)
    };

    // 날짜 변경 함수: 날짜 변경시 step 초기화, 데이터 재조회
    // const handleSetTimerDate = (newDate) => {
    //     setTimerDate(newDate);
    //     setStep(0);
    //     stopPlayback();
    // };
    const handleSetTimerDate = (newDate) => {
        const prevDate = timerDate;
        setTimerDate(newDate);

        // 날짜가 실제로 변경된 경우에만 step 리셋
        if (prevDate !== newDate) {
            setStep(0);
        }

        if (isPlaying) {
            pausePlayback(); // stopPlayback 대신 pausePlayback
        }
    };

    // 컴포넌트 언마운트 시 정리
    useEffect(() => {
        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, []);

    // timerDate, isPlaying 변경에 따라 데이터 갱신
    // useEffect(() => {
    //     const fetchData = async () => {
    //         if (isPlaying) return; // 재생중엔 갱신 금지
    //         try {
    //             const dateFormatted = formatDateForApi(timerDate);
    //             const sdtm = `${dateFormatted}00`;  // 시작시간 00시
    //             const edtm = `${dateFormatted}23`;  // 종료시간 23시
    //             const url = `newdashboard/roadtraffic/GetInOutTrafficByHour?sdtm=${sdtm}&edtm=${edtm}`;
    //             const response = await ApiService.get(url);

    //             if (response.status === 200) {
    //                 const data = response.data;
    //                 let rows = data.rows?.length === 0
    //                     ? Array(24).fill({}).map((_, i) => ({ hh: i }))
    //                     : data.rows;

    //                 // 오늘 날짜라면 maxStep을 현재 시간 -1 시로 제한
    //                 const todayStr = getToday();
    //                 let newMaxStep = rows.length - 1;

    //                 if (timerDate === todayStr) {
    //                     const nowHour = new Date().getHours();
    //                     newMaxStep = Math.min(newMaxStep, nowHour - 1);
    //                     if (newMaxStep < 0) newMaxStep = 0;
    //                     rows = rows.slice(0, newMaxStep + 1);
    //                 }

    //                 setMaxStep(newMaxStep);
    //                 setStep(0);
    //                 setDataByHour(rows);
    //             }
    //         } catch (error) {
    //             console.error('데이터 조회 실패:', error);
    //         }
    //     };
    //     fetchData();
    // }, [timerDate, isPlaying]);
    useEffect(() => {
        const fetchData = async () => {
            if (isPlaying) return;
            try {
                const dateFormatted = formatDateForApi(timerDate);
                const sdtm = `${dateFormatted}00`;
                const edtm = `${dateFormatted}23`;
                const url = `newdashboard/roadtraffic/GetInOutTrafficByHour?sdtm=${sdtm}&edtm=${edtm}`;
                const response = await ApiService.get(url);

                if (response.status === 200) {
                    const data = response.data;
                    let rows = data.rows?.length === 0
                        ? Array(24).fill({}).map((_, i) => ({ hh: i }))
                        : data.rows;

                    const todayStr = getToday();
                    let newMaxStep = rows.length - 1;

                    if (timerDate === todayStr) {
                        const nowHour = new Date().getHours();
                        newMaxStep = Math.min(newMaxStep, nowHour - 1);
                        if (newMaxStep < 0) newMaxStep = 0;
                        rows = rows.slice(0, newMaxStep + 1);
                    }

                    setMaxStep(newMaxStep);
                    setDataByHour(rows);
                }
            } catch (error) {
                console.error('데이터 조회 실패:', error);
            }
        };
        fetchData();
    }, [timerDate]); // 🔥 isPlaying 의존성도 제거

    return (
        <TrafficInOutHourContext.Provider
            value={{
                dataByHour,
                step,
                setStep,
                maxStep,
                isPlaying,
                startPlayback,
                stopPlayback,
                timerDate,
                pausePlayback,
                setTimerDate: handleSetTimerDate
            }}
        >
            {children}
        </TrafficInOutHourContext.Provider>
    );
}

export function SwItsTrafficOdMapChart() {
    const mapRef = useRef();
    const boundaryLayer = useRef();
    const prevOverlayIdsRef = useRef([]);
    const contextData = useContext(TrafficInOutHourContext);
    const { dataByHour, step, setStep, maxStep, isPlaying, startPlayback, stopPlayback, timerDate, setTimerDate, pausePlayback } = contextData || {};
    const [currentHour, setCurrentHour] = useState("00:00");

    const formatHour = (hour) => {
        const padded = String(hour).padStart(2, '0');
        return `${padded}시`;
    };
    // const handleChangeDate = (event) => {
    //     setTimerDate(event.target.value);
    //     stopPlayback();
    // };
    const handleChangeDate = (event) => {
        setTimerDate(event.target.value);
        pausePlayback(); // stopPlayback 대신 pausePlayback 사용
    };
    useEffect(() => {
        if (dataByHour && dataByHour[step]) {
            const hour = dataByHour[step].hh || step;
            setCurrentHour(formatHour(hour));
        } else {
            setCurrentHour(formatHour(step));
        }
    }, [dataByHour, step]);

    const targetDef = [
        { id: 'eW01', displayTitle: '의왕,군포', xyRoute: [126.993470, 37.323810] },
        { id: 'yI01', displayTitle: '용인,성남', xyRoute: [127.049300, 37.306970] },
        // { id: 'hS01', displayTitle: '화성,봉담', xyRoute: [127.008950, 37.298080] },
        { id: 'hS01', displayTitle: '화성,봉담', xyRoute: [127.01612, 37.239391] },
        { id: 'yI02', displayTitle: '용인,수지', xyRoute: [127.050580, 37.294210] },
        { id: 'yI03', displayTitle: '용인,기흥', xyRoute: [127.057000, 37.270210] },
        { id: 'yI04', displayTitle: '화성,동탄', xyRoute: [127.0662460, 37.247323] },
        { id: 'hS02', displayTitle: '화성,안산', xyRoute: [126.969730, 37.250800] }
    ];

    // 지도 및 레이어 초기 구성 (1회 실행)
    useEffect(() => {
        if (!mapRef.current) return;

        const map = mapRef.current.GetOlMap();

        if (!boundaryLayer.current) {
            boundaryLayer.current = new BoundaryVmsLayer(map);
        }

        map.addLayer(new CommonBoundaryLayer(map));
        map.addLayer(new CommonGuidelineLayer(map));
        map.addLayer(new CommonMarkerLayer(map));
    }, []);

    // 데이터 변경에 따른 오버레이 & 레이어 업데이트
    useEffect(() => {
        if (!mapRef.current || !dataByHour || dataByHour.length === 0) return;

        const map = mapRef.current.GetOlMap();
        const overlay = mapRef.current.GetOverlayContainer();
        const guidelineLayer = map.getLayers().getArray().find(layer => layer instanceof CommonGuidelineLayer);
        const markerLayer = map.getLayers().getArray().find(layer => layer instanceof CommonMarkerLayer);

        const row = dataByHour[step];
        if (!row) return;

        // 아이템을 그룹화하고 위치를 지정
        // 상단 3개
        const topItems = [
            {
                ...targetDef[0], //의왕 군포
                customX: 126.865,
                customY: 37.355,
                positioning: 'bottom-center'
            },
            {
                ...targetDef[1], // 용인 성남
                customX: 127.03,
                customY: 37.355,
                positioning: 'bottom-center'
            },
            {
                ...targetDef[3], // 용인 수지
                customX: 127.125,
                customY: 37.349,
                positioning: 'bottom-left'
            },
        ];

        // 중간 4개 (2x2 그리드 형태로)
        const middleItems = [
            {
                ...targetDef[2], // 화성 봉담
                // customX: 126.925,
                // customY: 37.305,
                customX: 126.93,
                customY: 37.225,
                positioning: 'center-right'
            },
            {
                ...targetDef[6], // 화성 안산 
                // customX: 126.93,
                // customY: 37.225,
                customX: 126.925,
                customY: 37.305,
                positioning: 'center-right'
            },
            {
                ...targetDef[4], // 용인 기흥
                customX: 127.128,
                customY: 37.2999,
                positioning: 'center-left'
            },
            {
                ...targetDef[5], // 화성 동탄
                customX: 127.098,
                customY: 37.225,
                positioning: 'center-left'
            }
        ];

        // 오른쪽 아래 1개
        const bottomRightItem = [
            {
                ...targetDef[4], // 용인 기흥
                customX: 126.99,
                customY: 37.25,
                positioning: 'top-left'
            }
        ];

        // 모든 아이템 합치기
        const customPositionedItems = [...topItems, ...middleItems];

        // 레이아웃 아이템 생성
        const layoutItems = customPositionedItems.map(p => ({
            id: p.id,
            x: p.customX,
            y: p.customY,
            displayTitle: p.displayTitle,
            inve: { key: row.hh, value: row[p.id + 'IN'] ?? 0 },
            outve: { key: row.hh, value: row[p.id + 'OUT'] ?? 0 },
            positioning: p.positioning,
            originalXY: p.xyRoute
        }));

        const totalIn = layoutItems.reduce((sum, item) => sum + (item.inve.value || 0), 0);
        const totalOut = layoutItems.reduce((sum, item) => sum + (item.outve.value || 0), 0);

        // 이전 오버레이 제거
        prevOverlayIdsRef.current.forEach(id => overlay.Remove?.(id));
        prevOverlayIdsRef.current = [];

        setTimeout(() => {
            // 개별 지역 오버레이 추가
            layoutItems.forEach(item => {
                const overlayId = `${item.id}-${step}`;
                overlay.AddOrUpdate?.(
                    overlayId,
                    [item.x, item.y], // 커스텀 좌표 사용
                    item.positioning, // 커스텀 포지셔닝 사용
                    () => <InOutStyledBoxWithBar
                        key={overlayId}
                        id={item.id}
                        title={item.displayTitle}
                        inValue={item.inve.value}
                        outValue={item.outve.value}
                    />
                );
                prevOverlayIdsRef.current.push(overlayId);
            });

            // 전체 교통량 오버레이 추가
            const totalOverlayId = `total-${step}`;
            overlay.AddOrUpdate?.(
                totalOverlayId,
                [126.58390, 37.306000], // 좌측 중앙 위치로 설정
                'center-left',
                () => <InOutStyledBoxWithBar
                    key={totalOverlayId}
                    id="total"
                    title="전체 교통량"
                    inValue={totalIn}
                    outValue={totalOut}
                    isTotal={true}
                />
            );
            prevOverlayIdsRef.current.push(totalOverlayId);
        });

        // 선과 마커 업데이트 
        guidelineLayer?.update(layoutItems.map(p => {
            const lineStart = [p.x, p.y];
            const lineEnd = p.originalXY;
            return [lineStart, lineEnd];
        }));

        markerLayer?.update(ToFeatures(targetDef.map(p => ({
            x: p.xyRoute[0],
            y: p.xyRoute[1]
        }))));
    }, [dataByHour, step]);
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            {/* 지도 */}
            {/* <div style={{ position: 'relative', width: '100%', height: '100%', top: '-20px', left: '0px' }}>
                <BaseMapView
                    ref={mapRef}
                    initViewData={{ zoom: 12.4, center: [127.01288, 37.290] }}
                />
            </div> */}
            <div style={{
                position: 'absolute',
                width: '75%', // 지도 영역 축소
                height: '100%',
                top: '-30px',
                right: '0px', // 오른쪽으로 정렬
                left: 'auto'
            }}>
                <BaseMapView
                    ref={mapRef}
                    initViewData={{ zoom: 11.7, center: [127.01288, 37.290] }}
                />
            </div>
            <div className={`${styles.playerWrap_rdTrf} ${styles.playerWrapInout_rdTrf} playerWrap`}>
                <div className={`${styles.player_rdTrf} flx a_center`}>

                    {/* 날짜 입력 필드 추가 */}
                    <div
                        className='flx a_center'
                        style={{
                            backgroundColor: 'var(--white-05)',
                            borderRadius: '10px',
                            padding: '6px 20px',
                            border: '1px solid var(--pr-50)',
                            marginRight: '12px',
                            height: '48px',
                        }}
                    >
                        <input
                            type="date"
                            value={timerDate} // value를 state와 동기화
                            onChange={handleChangeDate}
                            defaultValue={getToday()}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                color: '#fff',
                                fontSize: '23px',
                                fontWeight: '600',
                                outline: 'none',
                                height: '48px',
                                lineHeight:'48px'
                            }}
                        />
                    </div>

                    {/* 재생/정지 버튼 */}
                    {/* <div className={`${styles.playerBtnWrap_rdTrf} flx a_center`}>
                        <IconButton
                            onClick={isPlaying ? stopPlayback : startPlayback}
                            disabled={!dataByHour || dataByHour.length === 0}
                            sx={{ p: 0.5, scale: 2 }}
                        >
                            {isPlaying ? (
                                <StopIcon sx={{ fontSize: 32, color: 'white' }} />
                            ) : (
                                <PlayArrowIcon sx={{ fontSize: 32, color: 'white' }} />
                            )}
                        </IconButton>
                    </div> */}
                    <div className={`${styles.playerBtnWrap_rdTrf} flx a_center`}>
                        <IconButton
                            onClick={isPlaying ? pausePlayback : startPlayback}
                            disabled={!dataByHour || dataByHour.length === 0}
                            sx={{ p: 0.5, scale: 2 }}
                        >
                            {isPlaying ? (
                                <PauseIcon sx={{ fontSize: 32, color: 'white' }} />
                            ) : (
                                <PlayArrowIcon sx={{ fontSize: 32, color: 'white' }} />
                            )}
                        </IconButton>

                        <IconButton
                            onClick={stopPlayback}
                            sx={{ p: 0.5, scale: 2, marginLeft: 1 }}
                        >
                            <StopIcon sx={{ fontSize: 32, color: 'white' }} />
                        </IconButton>
                    </div>

                    {/* 슬라이더 */}
                    <Slider
                        className={`${styles.progress_rdTrf}`}
                        // value={step}

                        // min={0}
                        // max={maxStep}
                        // onChange={(e, newValue) => {
                        //     console.log("Slider changed:", newValue); // 디버깅용 로그 찍기
                        //     setStep(Number(newValue));
                        // }}
                        value={step}
                        min={0}
                        max={maxStep || 10} // fallback max 설정
                        onChange={(e, newValue) => {
                            console.log("✅ Slider moved to:", newValue);
                            setStep(Number(newValue));
                        }}
                        sx={{
                            width: '100%',
                            height: 3,
                            bgcolor: 'transparent',
                            mx: 2,
                            ml: 6,
                            color: 'var(--pr-60)',
                            '& .MuiSlider-thumb': {
                                height: 42,
                                width: 42,
                                backgroundColor: 'var(--pr-30-30)',
                                backdropFilter: 'blur(4px)',
                                border: '8px solid var(--pr-60)',
                                marginLeft: '10px',
                                '&:hover': {
                                    boxShadow: '0px 0px 0px 8px rgba(57, 76, 255, 0.16)',
                                },
                            },
                            '& .MuiSlider-track': {
                                height: 19,
                                borderRadius: 4,
                            },
                            '& .MuiSlider-rail': {
                                height: 20,
                                borderRadius: 10,
                                backgroundColor: 'var(--white-30)',
                                opacity: 1,
                            },
                            '& .MuiSlider-mark': {
                                backgroundColor: 'white',
                                height: 10,
                                width: 2,
                                marginTop: -3,
                            },
                            '& .MuiSlider-markLabel': {
                                color: 'white',
                                fontSize: '12px',
                            },
                        }}
                    />

                    {/* 시간 텍스트 */}
                    <Typography
                        sx={{
                            color: '#fff',
                            fontSize: '23px',
                            fontWeight: '600',
                            minWidth: '100px',
                            textAlign: 'center',
                            bgcolor: 'var(--white-05)',
                            borderRadius: '10px',
                            padding: '6px 20px',
                            border: '1px solid var(--pr-50)'
                        }}
                    >
                        {currentHour}
                    </Typography>
                </div>
            </div>
        </div>
    );
}

const getToday = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

// InOutStyledBoxWithBar 컴포넌트 수정
const InOutStyledBoxWithBar = ({ id, inValue, outValue, title, isTotal = false }) => {
    const diff = inValue - outValue;
    const diffAbs = Math.abs(diff);
    const isInMore = diff > 0;
    const isOutMore = diff < 0;

    // 전체 교통량일 경우 다른 스타일 적용
    if (isTotal) {
        return (
            <div style={{
                position: 'absolute',
                left: '20px', // 좌측 위치
                top: '50%',
                transform: 'translateY(-50%)',
                background: '#161b2d',
                color: '#fff',
                padding: '20px 24px',
                borderRadius: '16px',
                boxShadow: '0 0 20px rgba(93, 104, 242, 0.5)',
                width: '380px', // 박스 너비 증가
                height: '260px', // 높이 명시적 지정
                fontFamily: 'sans-serif',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}>
                <div style={{
                    fontWeight: 700,
                    marginBottom: 16,
                    fontSize: 40, // 폰트 크기 증가
                    color: '#fff',
                    textAlign: 'center',
                    borderBottom: '1px solid #2a2a2a',
                    paddingBottom: '12px'
                }}>
                    {title}
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: 30, // 폰트 크기 증가
                    fontWeight: 500,
                    color: '#eee',
                    marginBottom: 10,
                    padding: '8px',
                    borderRadius: '10px',
                    border: isInMore ? '2px solid #f45c96' : 'none', // 유입이 더 많을 때 테두리
                    background: isInMore ? 'rgba(244, 92, 150, 0.1)' : 'transparent'
                }}>
                    <span style={{ color: '#f45c96', fontSize: 30 }}>유입:</span>
                    <span style={{ fontWeight: 700, fontSize: 30 }}>{inValue.toLocaleString()} 대</span>
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: 30, // 폰트 크기 증가
                    fontWeight: 500,
                    color: '#eee',
                    padding: '8px',
                    borderRadius: '10px',
                    border: isOutMore ? '2px solid #5d68f2' : 'none', // 유출이 더 많을 때 테두리
                    background: isOutMore ? 'rgba(93, 104, 242, 0.1)' : 'transparent'
                }}>
                    <span style={{ color: '#5d68f2', fontSize: 30 }}>유출:</span>
                    <span style={{ fontWeight: 700, fontSize: 30 }}>{outValue.toLocaleString()} 대</span>
                </div>
            </div>
        );
    }

    // 일반 지역 데이터 박스
    const maxBarLength = 300; // 더 넓게
    const inPercent = inValue / Math.max(inValue + outValue, 1);
    const outPercent = outValue / Math.max(inValue + outValue, 1);

    const titleColor = isInMore ? '#f45c96' : isOutMore ? '#5d68f2' : '#ccc';
    const diffColor = titleColor;
    const diffBg = isInMore ? '#ffdce0' : isOutMore ? '#d0ebff' : '#eee';

    return (
        <div style={{
            background: '#161b2d',
            color: '#fff',
            padding: '20px',
            borderRadius: '16px',
            boxShadow: 'inset 0 0 5px rgba(0,0,0,0.4)',
            width: '340px', // 박스 크기 증가
            height: '200px',
            fontFamily: 'sans-serif',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }}>
            {/* 제목 */}
            <div style={{
                fontWeight: 700,
                marginBottom: 14,
                fontSize: 26, // 폰트 크기 증가
                color: titleColor,
                textAlign: 'center'
            }}>
                {title}
            </div>

            {/* 막대 그래프 */}
            {/* <div style={{
                display: 'flex',
                height: 24, // 높이 증가
                marginBottom: 16,
                borderRadius: '8px',
                overflow: 'hidden',
                width: `${maxBarLength}px`
            }}> */}
            <div style={{
                position: 'relative',
                display: 'flex',
                height: 24,
                marginBottom: 16,
                borderRadius: '8px',
                overflow: 'hidden',
                width: `${maxBarLength}px`,
                background: '#333' // 배경 추가로 퍼센트 글씨 가독성 확보
            }}>
                {/* <div style={{
                    background: '#f45c96',
                    width: `${(inPercent / (inPercent + outPercent)) * 100}%`,
                    transition: 'width 0.3s',
                }} /> */}
                {inPercent > 0 && (
                    <div style={{
                        background: '#f45c96',
                        width: `${(inPercent / (inPercent + outPercent)) * 100}%`,
                        transition: 'width 0.3s',
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: 20,
                        fontWeight: 'bold'
                    }}>
                        {`${Math.round(inPercent * 100)}%`}
                    </div>
                )}
                {/* <div style={{
                    background: '#5d68f2',
                    width: `${(outPercent / (inPercent + outPercent)) * 100}%`,
                    transition: 'width 0.3s',
                }} /> */}
                {outPercent > 0 && (
                    <div style={{
                        background: '#5d68f2',
                        width: `${(outPercent / (inPercent + outPercent)) * 100}%`,
                        transition: 'width 0.3s',
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: 20,
                        fontWeight: 'bold'
                    }}>
                        {`${Math.round(outPercent * 100)}%`}
                    </div>
                )}
            </div>

            {/* 수치 표시 */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: 25, // 폰트 크기 증가
                fontWeight: 500,
                color: '#eee',
                marginBottom: 16
            }}>
                <span style={{ color: '#f45c96' }}>유입: {inValue.toLocaleString()}</span>
                <span style={{ color: '#5d68f2' }} >유출: {outValue.toLocaleString()}</span>
            </div>

            {/* 차이 강조 */}
            {/* <div style={{
                color: diffColor,
                fontWeight: 'bold',
                fontSize: 22, // 폰트 크기 증가
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 12,
                padding: '12px 0',
                borderTop: '1px solid #2a2a2a',
                marginTop: 'auto'
            }}>
                {diff === 0 ? '→ 동일' : isInMore ? '↑ 유입 우세' : '↓ 유출 우세'}
                {diff !== 0 && (
                    <span style={{
                        backgroundColor: diffBg,
                        padding: '6px 14px',
                        borderRadius: '8px',
                        color: '#000',
                        fontSize: 20,
                        fontWeight: 700
                    }}>
                        {diffAbs.toLocaleString()}
                    </span>
                )}
            </div> */}
        </div>
    );
};